import { render, staticRenderFns } from "./QrPayment.vue?vue&type=template&id=2c1fe8a6&scoped=true"
import script from "./QrPayment.vue?vue&type=script&lang=js"
export * from "./QrPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fe8a6",
  null
  
)

export default component.exports